import React, { Suspense, useMemo } from 'react';
import { View, Text, Pressable } from 'react-native';
import PropTypes from 'prop-types';

import {
  CreateResponsiveStyle,
  screenWidth,
  maxWidthContainer,
} from '~global-screens';
import { Fonts, Colors, hs, vs } from '@web-styles';

const TagsitePostFilterPills = ({
  activeFilter,
  onFilterChange,
  contentCounts,
  colorTheme,
}) => {
  const styles = componentStyles();

  const filters = useMemo(() => {
    return [
      {
        id: 'article',
        title: 'Article',
        data: contentCounts.article || 0,
      },
      {
        id: 'pid_quiz',
        title: 'Quiz',
        data: contentCounts.quiz || 0,
      },
      {
        id: 'polling',
        title: 'Polls',
        data: contentCounts.poll || 0,
      },
    ];
  }, [contentCounts]);

  const handleFilterChange = (filterId) => {
    // If the clicked filter is already active, set to null (show all)
    // Otherwise, set to the clicked filter
    onFilterChange(activeFilter === filterId ? null : filterId);
  };

  return (
    <Suspense fallback={<></>}>
      <View
        style={styles('backgroundContainer')}
        nativeID="tagsite-filter-background">
        <View style={styles('pillsWrapper')} nativeID="tagsite-filter-pills">
          {filters.map((filter) => {
            const isActive = activeFilter === filter.id;
            const pillsStyle = {
              borderWidth: isActive ? 0 : 1,
              backgroundColor: isActive ? colorTheme : Colors.WHITE,
              borderColor: isActive ? 'transparent' : Colors.BLACK,
            };
            const letterSpacing = 0.2;
            return (
              <Pressable
                onPress={() => handleFilterChange(filter.id)}
                style={[styles('pills'), pillsStyle]}
                key={`filter-${filter.id}`}
                nativeID={`tagsite-filter-${filter.id}`}>
                <Text
                  style={[
                    Fonts('tags'),
                    {
                      letterSpacing,
                      color: isActive ? Colors.WHITE : Colors.BLACK,
                    },
                  ]}>{`${filter.title} (${filter.data})`}</Text>
              </Pressable>
            );
          })}
        </View>
      </View>
    </Suspense>
  );
};

const webStyles = {
  backgroundContainer: {
    backgroundColor: '#F2F2F2',
    width: '100%',
    alignItems: 'center',
  },
  pillsWrapper: {
    flexDirection: 'row',
    width: screenWidth * 0.88,
    maxWidth: maxWidthContainer,
    paddingVertical: 24,
    paddingHorizontal: 16,
    columnGap: 12,
  },
  pills: {
    paddingVertical: 6,
    paddingHorizontal: 30,
    borderRadius: 50,
    columnGap: hs(10),
    alignSelf: 'center',
  },
};

const mobileStyles = {
  backgroundContainer: {
    backgroundColor: '#F2F2F2',
    width: '100%',
  },
  pillsWrapper: {
    width: screenWidth,
    paddingVertical: hs(16),
    paddingHorizontal: vs(14),
    flexWrap: 'wrap',
    rowGap: 8,
  },
  pills: {
    paddingVertical: hs(5),
    paddingHorizontal: vs(8),
  },
};

const componentStyles = CreateResponsiveStyle(webStyles, mobileStyles);

TagsitePostFilterPills.propTypes = {
  activeFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  contentCounts: PropTypes.shape({
    total: PropTypes.number,
    article: PropTypes.number,
    quiz: PropTypes.number,
    poll: PropTypes.number,
  }).isRequired,
  colorTheme: PropTypes.string,
};

export default TagsitePostFilterPills;
